import { MatPaginatorIntl } from '@angular/material';
import { TRANSLATE } from './translatable';
import {Injectable} from "@angular/core";

@Injectable()
export class MatPaginatorIntlFr extends MatPaginatorIntl {

    itemsPerPageLabel = TRANSLATE('Résultats par page');
    nextPageLabel     = TRANSLATE('Page suivante');
    previousPageLabel = TRANSLATE('Page précédente');
    lastPageLabel = TRANSLATE('Dernière page');
    firstPageLabel = TRANSLATE('Première page');

    getRangeLabel = function (page, pageSize, length) {
        if (length === 0 || pageSize === 0) {
            return '0' + TRANSLATE('sur') + ' ' + length;
        }

        length = Math.max(length, 0);
        const startIndex = page * pageSize;
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;
        return startIndex + 1 + ' - ' + endIndex + ' ' + TRANSLATE('sur') + ' ' + length;
    };

}
